import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Professionals 45+ who feel like their "systems" are no longer working.', 'Recently diagnosed adults looking for practical tools, not just theory.', 'People who feel "overqualified" for their current struggles with simple tasks.', 'Creative entrepreneurs who are brilliant at the "big picture" but drowning in the details.'];
  const notForYou = ['People looking for a medical "cure" or pharmaceutical advice.', 'Those unwilling to spend 10 minutes a day setting up their environment.', 'Anyone looking for a traditional, rigid "hustle culture" planner.'];
  return <section className="py-16 md:py-24 px-4 bg-[#0B1A2E]" data-id="element-8">
      <div className="max-w-5xl mx-auto animate-fade-in-up delay-100" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-10">
          {/* For You */}
          <div className="bg-[#112240] p-8 rounded-2xl border-t-4 border-[#2DD4BF]" data-id="element-11">
            <h3 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-8" data-id="element-12">
              This Is For You If...
            </h3>
            <ul className="space-y-6" data-id="element-13">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-14">
                  <div className="bg-[#2DD4BF]/10 p-1 rounded-full shrink-0 mt-0.5" data-id="element-15">
                    <CheckIcon className="w-4 h-4 text-[#2DD4BF]" data-id="element-16" />
                  </div>
                  <span className="text-[#94A3B8] leading-relaxed" data-id="element-17">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-[#112240] p-8 rounded-2xl border-t-4 border-[#64748B]" data-id="element-18">
            <h3 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-8" data-id="element-19">
              This Is NOT For You If...
            </h3>
            <ul className="space-y-6" data-id="element-20">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <div className="bg-[#64748B]/10 p-1 rounded-full shrink-0 mt-0.5" data-id="element-22">
                    <XIcon className="w-4 h-4 text-[#ef4444]" data-id="element-23" />
                  </div>
                  <span className="text-[#64748B] leading-relaxed" data-id="element-24">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}